import * as Yup from 'yup';

const userSchema = Yup.object().shape({
  // firstName: Yup.string().required('First Name is required.'),
  // lastName: Yup.string().required('Last Name is required.'),
  name: Yup.string().required('Name is required.'),
  countryCallingCode: Yup.string().required('Country Code is required.'),
  mobileNumber: Yup.string().required('Mobile Number is required.'),
  userRole: Yup.string().required('User Role is required.'),
  // countryId: Yup.string().required('Country is required.'),
  // regionId: Yup.string().required('Region is required.'),
  // language: Yup.string().required('Language is required.'),
});

export default userSchema;